import React, { useEffect, useState } from "react";
import "./Counter.css";
import { useTimer } from "react-timer-hook";
import { Reserveseat } from "./Reserveseat";

import ShowcaseImg from "../assets/images/showcase-img.png";
import AskRightImg from "../assets/images/ask-right-img.jpg";
import TechAnalogyImg from "../assets/images/tech-analogy-img.png";
import RegisterImg from "../assets/images/register-img05.png";
import Form from "./Form";

function MyDaysTimer({ expiryTimestamp }) {
  const { seconds, minutes, hours, days } = useTimer({ expiryTimestamp });

  return (
    <div className="counter-days">
      <div className="coun-days-hours">
        <strong>DAYS</strong>
        <div className="counter-number">
          <span>{Math.floor(days / 10)}</span>
          <span>{days % 10}</span>
        </div>
      </div>
      <div className="coun-days-hours">
        <strong>HOURS</strong>
        <div className="counter-number">
          <span>{Math.floor(hours / 10)}</span>
          <span>{hours % 10}</span>
        </div>
      </div>
      <div className="coun-days-hours">
        <strong>MINUTES</strong>
        <div className="counter-number">
          <span>{Math.floor(minutes / 10)}</span>
          <span>{minutes % 10}</span>
        </div>
      </div>
    </div>
  );
}
const Counter = () => {
  function addDays(theDate, days) {
    return new Date(theDate.getTime() + days * 24 * 60 * 60 * 1000);
  }

  var newDate = addDays(new Date(), 12);
  const time = newDate;
  time.setSeconds(time.getSeconds());
  return (
    <div className="counter-section">
      <div className="counter_container">
        <div className="counter-you-ask">
          <div className="counter-ask-left">
             <div className="ask-title">Before<br></br>you <span>ask</span></div>
             <p className="you-will-text">Yes, You will be certified for this training program</p>
              <div className="showcase-box">
                <div className="showcase-text">
                <div className="showcase-image"><img src={ShowcaseImg} className="showcase-img" /></div>
                <p>Display Your My Equation E-Drive Certificate on Your Resume or LinkedIn Profile. Impress Prospective Employers with Tangible Proof of Your Expertise.</p>
                </div>   
              </div>
              <div className="showcase-box2 box3">
                <div className="showcase-text">
                <div className="showcase-image"><img src={RegisterImg} className="showcase-img" /></div>
                <Reserveseat />
                </div>   
              </div>
          </div> 
          <div className="counter-ask-right">
            <div className="ask-img-box">
            <img src={AskRightImg} className="ask-img" />  
            </div>
            <div className="showcase-bottom-right" id="counter-form">
            <div className="showcase-box showcase-box-mobile">
                <div className="showcase-text">
                <div className="showcase-image"><img src={ShowcaseImg} className="showcase-img" /></div>
                <p>Display Your My Equation E-Drive Certificate on Your Resume or LinkedIn Profile. Impress Prospective Employers with Tangible Proof of Your Expertise.</p>
                </div>   
              </div> 
              <div className="showcase-box2 box3 mobile">
                <div className="showcase-text">
                <div className="showcase-image"><img src={RegisterImg} className="showcase-img" /></div>
                <Reserveseat />
                </div>   
              </div>  
              <div className="tech-analogy-main">
              <div className="tech-analogy-box tech-img">
              <img src={TechAnalogyImg} className="tech-analogy" />
              </div>
              <div className="tech-analogy-box">
               <Form />
              </div> 
              </div> 
            </div>
          </div> 
         </div>  
    
 
 
        {/* <MyDaysTimer expiryTimestamp={time} /> */}
 
      </div>
    </div>
  );
};

export default Counter;
